import React, { useContext, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useGetHospitalProceduresQuery, useGetProcedureComparisonsQuery } from '../../api/apiSlice';
import { UserContext } from '../Hooks/useUser';
import ProcedureComparisonGraph from './ProcedureComparisonGraph';
import LoadingIndicator from '../LoadingIndicator';
import CardComparison from './CardComparison';
import ProcedureSearchDropdown from '../Procedures/ProcedureSearchDropdown';
import { theme } from '../../theme';

function ProcedureAnalytics() {
    const { user } = useContext(UserContext);
    const [ selectedProcedure, setSelectedProcedure ] = useState('');
    const [ selectedPhysicians, setSelectedPhysicians ] = useState([]);

    const { data: procedureList, isSuccess } = useGetHospitalProceduresQuery(user.hospital.id);
    const procedures = procedureList ? [...procedureList].sort((a, b) => a.name.localeCompare(b.name)) : [];

    const { data: procedureComparisons, isFetching } = useGetProcedureComparisonsQuery(
        { procedureId: selectedProcedure },
        { skip: !selectedProcedure }
    );

    const handleDropdownChange = (procedureId) => {
        setSelectedProcedure(procedureId);
        setSelectedPhysicians([]);
    }

    return (
        <Stack spacing={2}>
            <Stack px={4} pb={1} spacing={1} sx={{ position: 'sticky', top: 64, zIndex: 5, backgroundColor: theme.palette.background.white, borderBottom: '1px solid', borderColor: 'divider' }}>
                <Typography variant="heavy">
                    Procedure Analytics:
                </Typography>

                {isSuccess &&
                    <ProcedureSearchDropdown
                        options={procedures}
                        value={selectedProcedure}
                        onSelect={handleDropdownChange}
                    />
                }

                { !selectedProcedure && 
                    <Typography variant="normal" color="text.secondary">
                        Select a procedure from the dropdown above to view analytics.
                    </Typography>
                }
            </Stack>

            { isFetching && <LoadingIndicator /> }

            { selectedProcedure && !isFetching &&
                <Stack px={4} pb={2} spacing={2}>
                    <ProcedureComparisonGraph analysisData={procedureComparisons || {}} selectedPhysicians={selectedPhysicians} setSelectedPhysicians={setSelectedPhysicians} />
                    <CardComparison 
                        selectedCards={(procedureComparisons?.cardComparisons || []).filter(card => selectedPhysicians.includes(card.physician_id))} 
                        onClose={() => setSelectedPhysicians([])}
                    />
                </Stack>
            }

        </Stack>
    );
}

export default ProcedureAnalytics;
